export * from './baMultiCheckbox.component'



// WEBPACK FOOTER //
// /app/src/app/theme/components/baMultiCheckbox/index.ts